export function insertLineBreaks(text: any, breakInterval: any) {
  let result = '';
  for (let i = 0; i < text.length; i += breakInterval) {
    result += text.slice(i, i + breakInterval) + '\n';
  }
  // 将所有的 \n 替换为 <br> 标签
  return result.replace(/\n/g, '<br>');
}
